export class StickyBar extends window.BAO.CustomElement() {
  static get requiredExternalElements () {
    return ['trigger']
  }

  setupListeners () {
    super.setupListeners()

    this.onIntersect = this.onIntersect.bind(this)

    this.observer = new IntersectionObserver(this.onIntersect, {
      threshold: 0,
    })

    this.observer.observe(this.externalEls.trigger.element)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.observer) {
      this.observer.disconnect()
    }
  }

  /**
   * Shows the bar once the trigger (the product hero) has been scrolled fully
   * above the viewport, and hides it again when the hero is back in view.
   *
   * @param {IntersectionObserverEntry[]} entries
   *
   * @returns {void}
   */
  onIntersect (entries) {
    const entry = entries[entries.length - 1]

    const scrolledPast =
      !entry.isIntersecting && entry.boundingClientRect.bottom <= 0

    this.setAttribute('aria-hidden', String(!scrolledPast))
  }
}

if (!customElements.get('sticky-bar')) {
  customElements.define('sticky-bar', StickyBar)
}
